<template>
  <AvatarGroup :class="className" :style="style">
    <slot></slot>
  </AvatarGroup>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import AvatarGroup from 'primevue/avatargroup'
import type { MOPAvatarGroupProps } from './types'

export default defineComponent({
  name: 'MOPAvatarGroup',
  components: {
    AvatarGroup
  },
  inheritAttrs: false
})
</script>

<script setup lang="ts">
const props = withDefaults(defineProps<MOPAvatarGroupProps>(), {
  className: undefined,
  style: undefined
})
</script>
